import { createFileRoute } from "@tanstack/react-router";
import { useApp } from "@/context/AppContext";
import { ClientDashboard } from "@/pages/client/ClientDashboard";
import { Dashboard } from "@/pages/team/Dashboard";

/**
 * Gleiche Adresse, zwei Welten: Seit T014 entscheidet die echte Konto-Rolle
 * aus der Sitzung, welche Startseite erscheint — der Umschalter ist weg.
 */
export const Route = createFileRoute("/_angemeldet/")({
	component: Startseite,
});

function Startseite() {
	const { role } = useApp();
	return role === "mitarbeiter" ? <Dashboard /> : <ClientDashboard />;
}
